import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { Header, Title } from '../layout';
import { TimerComponent, ssgFormsAdapters } from '../common';
import { LoadingPane, accessibilityNotificationsEmitter } from '@social-solutions/ssg-forms';
import './intake-form.scss';

const genericErrorMessage = 'Uh oh. There was a problem. We weren\'t able to save your intake information. Please try again later.';
const participantAlreadyExistsMessage = 'Participant already registered with this organization.';
const successMessage = 'Success! You have successfully submitted your application for services.';
let partialSuccessMessage = 'Thank you for your submission! The organization may reach out for additional information to complete your records.'
export class IntakeFormSubmitResultComponent extends Component {

  componentDidMount() {
    const { intake, match } = this.props;
    const { params } = match;
    const { id } = params;
    const { formSubmission } = intake || {};
    const submissionState = formSubmission && formSubmission.get(id);
    const { isFetching, err, isValid } = submissionState || { isFetching: false };

    if (!isFetching && isValid) {
      if (!err) {
        accessibilityNotificationsEmitter.polite(successMessage);
      }
      accessibilityNotificationsEmitter.polite("This page will refresh with a blank form in 15 seconds.");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { intake, match } = this.props;
    const { params } = match;
    const { id } = params;
    const { formSubmission, intakeForms } = intake || {};
    const submissionState = formSubmission && formSubmission.get(id);
    const { isFetching, err } = submissionState || { isFetching: false };

    const { intake: prevIntake } = prevProps;
    const { formSubmission: prevFormSubmission } = prevIntake || {};
    const prevSubmissionState = prevFormSubmission && prevFormSubmission.get(id);
    const { isFetching: wasFetching } = prevSubmissionState || { isFetching: false };

    const { url } = match;
    const intakeState = intakeForms && intakeForms.get(id);
    var intakePath = url && url.replace('/results', '');

    if (wasFetching && !isFetching) {
      if (!err) {
        const intakeForm = intakeState.data;
        const messageType = intakeForm && intakeForm.messageType;
        let redirectLink = intakeForm && intakeForm.redirectLink;

        if (!!messageType && messageType === 'redirect') {
          if (!redirectLink) {
            redirectLink = intakePath;
          }
          setTimeout(() => { window.location.replace(redirectLink) }, 3000)
        }
        accessibilityNotificationsEmitter.polite(successMessage);
      }
      accessibilityNotificationsEmitter.polite("This page will refresh with a blank form in 15 seconds.");
    }
  }

  handleRedirect() {
    const { redirectTo, match } = this.props;
    const { url } = match;
    var intakePath = url && url.replace('/results', '');
    redirectTo(intakePath);
  }

  render() {
    const { intake, match } = this.props;
    const { params, url } = match;
    const { id } = params;
    const { formSubmission, intakeForms } = intake || {};
    const intakeState = intakeForms && intakeForms.get(id);
    const submissionState = formSubmission && formSubmission.get(id);
    const { isFetching, isValid, data, err } = submissionState || { isFetching: false };
    let isPartialSuccess = false;


    // Checking if a success_partial string was sent from the api. Occurs when a touchpoint fails to save because a hidden required field was not filled out.
    if (data && data.infoList) {
      const { infoList = [] } = data;
      isPartialSuccess = infoList.includes("success_partial");
      if (isPartialSuccess) {
        let requestId = infoList.find(item => item.includes("request_id")).split(":")[1];
        partialSuccessMessage = `Thank you for your submission! Please store this REQUEST ID “${requestId}” for your records.\nThe organization may reach out for additional information to complete your records.`;
      }
    }

    var intakePath = url && url.replace('/results', '');
    var submissionLoadingState = ssgFormsAdapters.convertLoadingState(submissionState);

    const intakeForm = intakeState && intakeState.data;
    const messageType = intakeForm && intakeForm.messageType;
    const customMessage = intakeForm && intakeForm.customMessage;
    const dupeCheckNotificationType = intakeForm && intakeForm.dupeCheckNotificationType;

    /**
     * This accounts for the possibility that the page is refreshed.
     * In this case no data is loaded, so we have to fake data to get the content to show.
     */
    if (err || (!isFetching && !isValid && !data)) {
      var errDisplay = err.requestId
        ? `Uh oh. There was a problem. We weren't able to save your intake information, but here is a REQUEST ID “${err.requestId}” for your records.\nPlease try again later.`
        : genericErrorMessage;

      if (err && err.errorCode === 'duplicate' && dupeCheckNotificationType !== 'generic') {
        errDisplay = participantAlreadyExistsMessage;
      }
      if (err && err.errorCode === 'Intake Partial Success') {
        console.log(err)
        errDisplay = err.message || 'somethings wrong';
      }
      submissionLoadingState.data = {};
      submissionLoadingState.error = {
        alertLevel: 'error',
        errorCode: 'intake-failure',
        errorMessage: errDisplay,
      }
    }

    const displayMessage = isPartialSuccess ? partialSuccessMessage : successMessage;

    return (
      <div>
        <Header />
        <Title title="Intake Results" />
        <div id="view" className="intake-view">
          <LoadingPane
            loadingState={submissionLoadingState}
            loadingMessage={'Submitting intake form...'}
            css={{ coverContent: '' }}>
            <div className="margin-override">
              {!err && isValid ? <h2 id="success-message" className="ssg-forms-text large">{displayMessage}</h2> : null}
              {(err || messageType === 'kiosk' || !messageType) && (!isPartialSuccess) ? (
                <p className="ssg-forms-text normal">
                  This page will refresh with a blank form in <TimerComponent time={15} onExpire={() => this.handleRedirect()} /> seconds.
                  <span>{" "}<a href={intakePath}>Click here</a> to load a new form now.</span>
                </p>)
                : <p><a href={intakePath}>Click here</a> to load a new form.</p>}
              {!err && messageType === 'custom' ? (
                <p className="ssg-forms-text normal" id="customMessage">
                  {customMessage}
                </p>) : null}
            </div>
          </LoadingPane>
        </div>
      </div>
    );
  }
}

IntakeFormSubmitResultComponent.propTypes = {
  intake: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.isRequired,
    })
  })
};

const mapStateToProps = ({ intake }) => {
  return {
    intake
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    redirectTo: bindActionCreators(push, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IntakeFormSubmitResultComponent);



// WEBPACK FOOTER //
// src/intake/intake-form-submit-result.component.js